import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

export interface StoryListReqBody {
    count?: number;
    page?: number;
    sortBy?: string;
}

export interface StoryReportReqBody {
    reportType: number;
}

interface StoryQueryParams {
    mapid: string;
    XID: string;
    SID?: string;
}

class StoryGateway extends Gateway {
    protected readonly _contextPath = "map/place/story";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        list: "list",
        count: "count",
        add: "add",
        update: "update",
        delete: "delete",
        report: "report",
    };

    public async reqStoryCount(param: StoryQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.count,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqStoryList(param: StoryQueryParams, body: StoryListReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.list,
            ...param,
        }
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqAddStory(param: StoryQueryParams, body: FormData): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.add,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqDeleteStory(param: StoryQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.delete,
            ...param,
        };
        
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqReportStory(param: StoryQueryParams, body: { [key: string]: any }): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.report,
            ...param,
        };

        return await this.request(Method.POST, undefined, queryParam, body)
    }
}

export { type StoryQueryParams, StoryGateway  };
